<template>
  <div>
  <a class="top-right-align" :href="video" target="_blank">
    follow link
  </a>
  <input type="text" autocomplete="off" maxlength="256" class="text-field w-input" :placeholder="fname" @change="update()" v-model="video">
</div>
</template>

<script>
export default {
	name: 'video',
	props: ['slg', 'fname'],
	data(){
		return{
			video:''
		}
	},
	methods:{
		update(){
			console.log(this.video)
			if (!this.$parent.info[this.slg]){this.$parent.infop[this.slg] = {}}
			this.$parent.info[this.slg].url = this.video
		}
	},
	mounted(){
			if (this.$parent.info[this.slg]){
				this.video = this.$parent.info[this.slg].url
				//console.log(this.video)
			} else {
				this.$parent.info[this.slg]={}
				this.$parent.info[this.slg].url =''
				}
	},
	watch:{
		video(){
			this.$parent.info[this.slg].url = this.video
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
